export const config = {
  isDevelopment: () => process.env.NODE_ENV !== 'production',
  isProduction: () => process.env.NODE_ENV === 'production',
  API: process.env.VUE_APP_API_SERVER
}
